import { fromJS } from 'immutable';
import localStore from 'store';
import differenceInHours from 'date-fns/differenceInHours';

export function restoreState(key, defaultState, timeout = 24) {
  const storedState = localStore.get(key);
  const diff = differenceInHours(new Date(), storedState && storedState.$saved);
  const stateIsValid = diff < timeout;
  return stateIsValid ? fromJS(storedState).set('$restored', Date.now()) : defaultState;
}
